var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 21 21",
    fill: "none",
    className: "injected-svg",
    "data-src": "/icons/new/menu-scenes.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.442 16.222c-.458.107-.921.187-1.387.24a6.15 6.15 0 0 1-4.5 4.266 10.29 10.29 0 0 1-4.7 0 6.15 6.15 0 0 1-4.583-4.583 10.29 10.29 0 0 1 0-4.7 6.15 6.15 0 0 1 4.267-4.5c.052-.466.132-.929.24-1.387A7.037 7.037 0 0 1 10.022.314a11.866 11.866 0 0 1 5.42 0 7.037 7.037 0 0 1 5.243 5.244 11.866 11.866 0 0 1 0 5.42 7.037 7.037 0 0 1-5.244 5.244Zm-5.42 0c.741.174 1.495.275 2.25.304a4.492 4.492 0 0 1-3.096 2.588 8.631 8.631 0 0 1-3.942 0 4.492 4.492 0 0 1-3.348-3.348 8.631 8.631 0 0 1 0-3.942 4.493 4.493 0 0 1 2.588-3.096 11.864 11.864 0 0 0 .304 2.25 7.037 7.037 0 0 0 5.245 5.244Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet);
export default __webpack_public_path__ + "static/media/set.baf11ce1eda9319afe061d040a05d09b.svg";
export { ForwardRef as ReactComponent };